
export type HorizontalAlignment = 
  | 'left'
  | 'right'
  | 'center';